<div class="exercicio-list">
  <section>
    <app-table
        [listColumns]="listColumns"
        [listData]="data"
        [listActions]="listActions"
        [filterForm]="filterForm"
        [canCreate]="false"
        [canExport]="false"
        [canView]="false"
        title="Suporte Local"
        filterField="pergunta"
    >
  </app-table>
  </section>
</div>
<app-loading [loader]="isLoading"></app-loading>